import axios, { AxiosError, AxiosResponse } from 'axios';
import AppConfig from '../AppConfig';
import setupInterceptors from './setupInterceptor';
import { removeToken } from './tokenUtils';

const employeeExperienceAxiosInstance = axios.create({
  baseURL: AppConfig.EMPLOYEE_EXPERIENCE_BASE_URL as string,
  // headers: {
  //   'x-plum-token':
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJJZCI6Ilp1d2JjZTRTT2M5WTJZWW9UNXF1Iiwib3JnYW5pc2F0aW9uSWQiOiJETm9EM0FsNjU2ajBBNHpiaVBDaSIsImVtYWlsSWQiOiJ2aW5heWdvdWRhQHBsdW1ocS5jb20iLCJzb3VyY2UiOiJNRU1CRVJTIiwib25lVGltZUNvZGVLZXkiOiJQTXV2MzNtT08iLCJpYXQiOjE2OTE2NDg1MzIsImV4cCI6MTcyNDM2NDg1MzJ9.XzYGxK22JZ-3v2tJK1_kWPFvuhLkDaxET-eG5Vxc5GU',
  // },
});

employeeExperienceAxiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (typeof window?.NativeBridge?.onNativeLogout === 'function') {
        removeToken();
        window?.NativeBridge?.onNativeLogout();
      }
    }
    return Promise.reject(error);
  }
);

setupInterceptors(employeeExperienceAxiosInstance)

export default employeeExperienceAxiosInstance;
